import App from '../vue/clients/messages/app.vue';

export default {
  el: '#messages',
  components: {
    App,
  }
};
